import { render, staticRenderFns } from "./GroupSet.vue?vue&type=template&id=1931e768&scoped=true"
import script from "./GroupSet.vue?vue&type=script&lang=js"
export * from "./GroupSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931e768",
  null
  
)

export default component.exports